import React, { createElement, useEffect, useMemo } from "react";
import Tab from "./Tab/Tab";
import TabContentPanel from "./Tab/TabContentPanel";
import TabsNavBar from "./TabsNavBar/TabsNavBar";
import { TabsProps } from "./types";

const Tabs = ({
  activeKey,
  onChange,
  children,
  navBarProps,
  shouldRenderContentBelowTabs = true,
}: TabsProps) => {
  const onClickTabItem = (newActiveTabKey: string) => {
    onChange(newActiveTabKey);
  };

  const tabs = useMemo(() => {
    const childArray = Array.isArray(children) ? children : [children];

    return childArray.filter((tab) => {
      return React.isValidElement(tab) && tab.type === createElement(Tab).type;
    });
  }, [children]);

  useEffect(() => {
    if (!activeKey && tabs?.length) {
      onClickTabItem(tabs[0]?.props?.tabKey);
    }
  }, [activeKey, tabs]);

  return (
    <>
      {shouldRenderContentBelowTabs ? (
        <>
          <TabsNavBar
            onClick={onClickTabItem}
            activeKey={activeKey}
            tabs={tabs}
            {...(navBarProps ?? {})}
          />
          <TabContentPanel
            activeKey={activeKey}
            tabs={tabs}
          />
        </>
      ) : (
        <>
          <TabContentPanel
            activeKey={activeKey}
            tabs={tabs}
          />
          <TabsNavBar
            onClick={onClickTabItem}
            activeKey={activeKey}
            tabs={tabs}
            {...(navBarProps ?? {})}
          />
        </>
      )}
    </>
  );
};

export default Tabs;
